import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';

import { TableColumn } from 'components/NewTable/type';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { isType, localeTw, userTypeList } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import {
  blobDownload,
  getSample,
  postSearch,
  snackBarRsp,
  confirm,
  deleteItem,
  upload,
  postExcel,
} from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Select from 'components/Material/Select';
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import CheckBox from 'components/Material/Checkbox';
import Input from 'components/Material/Input';
import WarehouseModal from 'components/Modal/WareHouseModal';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Header from 'components/Header';
import {
  checkboxChange,
  formatDate,
  getDateDayPlus,
  getFindDropDownList,
  getWarehouse,
  initWhrehhouse,
  inputChange,
  selectChange,
} from '../../../main_func';

import { Iresult, Imaster } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);
/** 拆櫃預定表維護 */
const ACInOutDetailQry = (): JSX.Element => {
  const classes = useStyles();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'acInOutDetailQry';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');

  const [comNoOptions, setComNoOptions] = useState<Ioption[]>([]);
  const [doorTypeIdOptions, setDoorTypeIdOptions] = useState<Ioption[]>([]);
  const [eaderIdOptions, seteaderIdOptions] = useState<Ioption[]>([]);

  const masterDefaultValue: Imaster = {
    // 儲區名稱
    comNo: '',
    comName: '',
    doorTypeId: '',
    doorType: '',
    readerId: '',
    readerName: '',
    empName: '',
    recordTimeStart: getDateDayPlus(),
    recordTimeEnd: getDateDayPlus(),
    recordTimeEndValid: false,
    recordTimeStartValid: false,
    chkCode1: '',
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',

    pageSize: 100,
  };
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());

  useEffect(() => {
    getFindDropDownList('findDropDownDoorMac', {
      warehouse: locationCode,
      doorTypeValue: master.doorTypeId,
    }).then((item) => {
      seteaderIdOptions(item);
    });
  }, [master.doorTypeId]);

  useEffect(() => {
    getFindDropDownList('findDropDownCompany', {
      warehouse: locationCode,
    }).then((item) => {
      setComNoOptions(item);
    });
    getFindDropDownList('findDropDownDoorType', {
      warehouse: locationCode,
    }).then((item) => {
      setDoorTypeIdOptions(item);
    });
  }, [master.warehouse]);

  useEffect(() => {
    getFindDropDownList('findDropDownCompany', {
      warehouse: locationCode,
    }).then((item) => {
      setComNoOptions(item);
    });
    getFindDropDownList('findDropDownDoorType', {
      warehouse: locationCode,
    }).then((item) => {
      setDoorTypeIdOptions(item);
    });
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType) ||
        isType(userTypeList.topType, userType) ||
        isType(userTypeList.type4, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({
      ...prev,
      warehouse: masterDefaultValue.warehouse,
    }));
  }, [userType]);

  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        checkboxSelection: false,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '姓名',
        field: 'empName',
        width: 300,
      },
      {
        headerName: '公司',
        field: 'comName',
        width: 300,
        editable: true,
      },
      {
        headerName: '門別',
        field: 'readerName',
        width: 300,
      },
      {
        headerName: '進出日期',
        field: 'inOutDate',
        width: 300,
      },
      {
        headerName: '進出時間',
        field: 'inOutTime',
        width: 300,
      },
      {
        headerName: '門禁狀態',
        field: 'recordStatus',
        width: 300,
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };
  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postSearch(apiName, {
      comNo: master.comNo,
      doorType: master.doorTypeId,
      warehouse: master.warehouse,
      readerId: master.readerId,
      recordTimeStart: formatDate(master.recordTimeStart, 'yyyyMMdd'),
      recordTimeEnd: formatDate(master.recordTimeEnd, 'yyyyMMdd'),
      empName: master.empName,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    // TODO 確認List名稱
    const { data: dataTemp } = result.data;
    const { ACInOutDetailQryAcInOutDetail: rowDetailsTemp } =
      (dataTemp as {
        ACInOutDetailQryAcInOutDetail: unknown | unknown[];
      }) || {};
    const data = result.data.data as Iresult[];
    console.log(data);
    if (data && (data || []).length > 0) {
      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      const result = await postExcel(apiName, {
        comNo: master.comNo,
        doorType: master.doorTypeId,
        warehouse: master.warehouse,
        readerId: master.readerId,
        recordTimeStart: formatDate(master.recordTimeStart, 'yyyyMMdd'),
        recordTimeEnd: formatDate(master.recordTimeEnd, 'yyyyMMdd'),
        empName: master.empName,
      });

      blobDownload(
        result,
        enqueueSnackbar,
        `${formatDate(master.recordTimeStart, 'yyyyMMdd')}_${formatDate(
          master.recordTimeEnd,
          'yyyyMMdd'
        )}_${master.warehouse}_人員進出歷程清單.xlsx`
      );
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };
  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'getExcel':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    console.log(updateObj);
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };
  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 人員進出歷程查詢
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*快遞倉站：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>進出日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateSePickersTyping
                required
                updateData={updateData}
                style={{ maxWidth: 600 }}
                names={['recordTimeStart', 'recordTimeEnd']}
                data={master}
                seInterval={31}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>公司：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.comNo}
                onChange={selectChange(updateData)}
                name="comNo"
                options={comNoOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>設備：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.doorTypeId}
                onChange={selectChange(updateData)}
                name="doorTypeId"
                options={doorTypeIdOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>門別：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.readerId}
                onChange={selectChange(updateData)}
                name="readerId"
                options={eaderIdOptions}
                // disabled={options.length === 0}
              />
            </Grid>
            <span style={{ color: 'red', display: 'contents' }}>
              請先選擇設備
            </span>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>姓名：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={35}
                value={master.empName}
                name="empName"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('getExcel')}
            >
              下載EXCEL
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>

      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};

export default ACInOutDetailQry;
